import useTranslation from "next-translate/useTranslation";
import classes from "./TypologieSelectView.module.scss";

export default function TypologieSelectView({
  hideTitle = false,
  onTypologieChange,
  typologies,
}: {
  hideTitle?: boolean;
  onTypologieChange: (typologie: number) => void;
  typologies: number[];
}) {
  const { t } = useTranslation("annonceAchat");

  // const [selectedTypologie, setSelectedTypologie] = useState<number>(-1);
  // const [chambresExact, setChambresExact] = useState<boolean>(false);

  // useEffect(() => {
  // selectedTypologie === -1
  //   ? onTypologieChange([])
  //   : chambresExact
  //   ? onTypologieChange([selectedTypologie])
  //   : onTypologieChange(
  //       [0, 1, 2, 3, 4, 5].filter((i) => i >= selectedTypologie)
  //     );
  // if (selectedTypologie !== -1) {
  // onTypologieChange(0)
  // }
  // else if (chambresExact) {
  // onTypologieChange(selectedTypologie)
  // }
  // else {
  //
  // 	onTypologieChange(selectedTypologie);
  // }
  // }, []);
  const arrayTypologie = !hideTitle ? [0, 1, 2, 3, 4, 5] : [0, 1, 2, 3, 4];
  return (
    // <Grid container>
    <div className={classes.container}>
      {!hideTitle && (
        <div>
          <span
            style={{
              paddingLeft: "17px",
              fontWeight: 500,
              fontSize: "14px",
            }}
          >
            {t("Chambres")}
          </span>
        </div>
      )}
      {/* </Grid> */}
      {/* <Grid
        container
        spacing={0}
        padding={1}
        style={{
          height: "60px",
        }}
      > */}
      <div
        className={classes.roomsNumContainer}
        style={hideTitle ? { margin: "0px" } : {}}
      >
        {arrayTypologie.map((i, idx) => (
          // <Grid item xs={2} key={i}>
          <div className={classes.roomsNumInnerContainer} key={idx}>
            <button
              className={`${classes["mobile--filtres--typologies"]} ${
                typologies.includes(i)
                  ? classes["mobile--filtres--typologies--active"]
                  : ""
              }`}
              // style={{ paddingLeft: "2px" }}
              onClick={(e) => {
                onTypologieChange(i);
              }}
            >
              <span>
                {/* {i === 0
                  ? t("Studio")
                  : `${i}${i === arrayTypologie.length - 1 ? "+" : ""}`} */}
                {i === 0
                  ? "0"
                  : `${i}${i === arrayTypologie.length - 1 ? "+" : ""}`}
              </span>
            </button>
            {/* </Grid> */}
          </div>
        ))}
        {/* </Grid> */}
      </div>
      {/* <Grid item xs={12}>
        <div style={{ paddingLeft: "20px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={chambresExact}
                onChange={(e) => {
                  if (chambresExact) {
                    setChambresExact(false);
                  } else {
                    setChambresExact(true);
                  }
                  setSelectedTypologie(-1);
                }}
              />
            }
            label={t("Utiliser le nombre exact de chambres")}
          />
        </div>
      </Grid> */}
      {/* </Grid> */}
    </div>
  );
}
